import type { SVGProps } from "react";

export function IconDarkPurpleDocuments(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.125 7.5625H4.8125V29.5625H24.0625V16.5M15.125 7.5625H17.1875C20.9845 7.5625 24.0625 10.6405 24.0625 14.4375V16.5M15.125 7.5625V16.5H24.0625M8.9375 3.4375H15.125H17.1875C23.2626 3.4375 28.1875 8.36237 28.1875 14.4375V16.5V25.4375"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
    </svg>
  );
}
